<div *ngIf="theme">
  <app-ranklist
    [ranklist]="(ranklist$ | async)!"
    [rooms]="rooms"
    (filterChange)="onFilterChange($event)"
    [filters]="filters"
    [loading]="(loading$ | async)!"
    [theme]="theme"
    [branches]="branches"
    [namespace]="namespace"
    [namespaces]="namespaces"
    [roomId]="roomId"
  ></app-ranklist>
</div>
